import React, { useEffect, useState } from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import { SimpleLayout } from '../components/SimpleLayout'
import SEO from './../components/SEO'
import 'react-vertical-timeline-component/style.min.css';


function WorkIcon(props) {
    return (
        <img
            src={props.logo}
            alt=""
            className="rounded-full"
            loading="lazy"
            decoding="async"
            data-nimg="1"
            unoptimized
        />
    )
}

export default function ResumePage() {
    const [jsonData, setJsonData] = useState(null);

    let resume = {
        "work": [
            {
                "company": "Richfill Enterprises",
                "title": "Full Stack Engineer",
                "logo": "./uploads/exp/richfill.jpg",
                "start": "08/2022",
                "end": {
                    "label": "Present",
                    "dateTime": 2024
                },
                "feats": [
                    "Designed and implemented cloud-based solutions, improving reliability.",
                    "Led development teams and mentored junior developers.",
                    "Optimized backend systems for better performance."
                ]
            },
            {
                "company": "Martech Stores",
                "title": "Fullstack Developer (Laravel + Flutter)",
                "logo": "./uploads/exp/martech.png",
                "start": "09/2022",
                "end": "05/2024",
                "feats": [
                    "Built and deployed secure APIs for web and mobile.",
                    "Redesigned UI, increasing customer engagement.",
                    "Published mobile apps and conducted code reviews."
                ]
            },
            {
                "company": "Veegil Media",
                "title": "Full Stack Developer (Nest.js + React + Plotly.py)",
                "logo": "./uploads/exp/veegil.jpg",
                "start": "08/2023",
                "end": "12/2023",
                "feats": [
                    "Developed microservices with Nest.js and Docker.",
                    "Integrated automated testing and improved team efficiency.",
                    "Built a responsive election monitoring map."
                ]
            },
            {
                "company": "Kolhab Technologies",
                "title": "Full Stack Development Team Lead",
                "logo": "./uploads/exp/kolhab.png",
                "start": "09/2021",
                "end": "10/2022",
                "feats": [
                    "Led a team to build web applications, speeding up delivery.",
                    "Introduced Agile methodologies and coding standards.",
                    "Mentored junior developers and improved system reliability."
                ]
            },
            {
                "company": "DesignIT Africa",
                "title": "Frontend Developer",
                "logo": "./uploads/exp/designit.jpg",
                "start": "08/2020",
                "end": "12/2021",
                "feats": [
                    "Optimized UI performance and reduced load times.",
                    "Collaborated with product and design teams.",
                    "Conducted usability tests for better user experience."
                ]
            },
            {
                "company": "Freelance",
                "title": "Freelance Web Developer",
                "logo": "./uploads/exp/tao.jpg",
                "start": "10/2018",
                "end": "01/2020",
                "feats": [
                    "Developed custom websites and applications.",
                    "Designed scalable front-end architectures.",
                    "Built API endpoints and documented projects."
                ]
            }
        ],
        "education": [
            {
                "degree": "Bachelor of Science: Mechatronics Engineering",
                "school": "Bells Univeristy of Technology",
                "logo": "./uploads/exp/bells.jpg",
                "start": "11/2022",
                "end": {
                    "label": "Present",
                    "dateTime": 2023
                },
                "feats": [

                ]
            },
            {
                "degree": "High School Diploma",
                "school": "Most High College",
                "logo": "./uploads/exp/mhc.jpg",
                "start": "09/2016",
                "end": "07/2022",
                "feats": [

                ]
            }
        ]
    };

    useEffect(() => {
        fetch('/data/resume.json')
            .then((response) => response.json())
            .then((data) => setJsonData(data))
            .catch((error) => console.error('Error fetching Data JSON:', error));
    }, []);

    if (jsonData != null) {
        resume = jsonData;
    }
    return (
        <>
            <SEO
                title='Resume | TheAdeyemiOlayinka'
                description='A timeline of my notable working experiences in the tech world.'
                name='TheAdeyemiOlayinka.'
                type='profile' />
            <SimpleLayout
                title="A timeline of my notable working experiences in the tech world."
                intro="Explore my professional journey and accomplishments through the timeline below. I've navigated the digital landscape, honed my skills, and contributed to diverse projects. From work experiences to educational milestones, this timeline tells my story in the tech world."
            >
                <center><h1 className="text-base text-zinc-800 dark:text-zinc-100 font-size-30px" >Work History</h1></center>
                <VerticalTimeline>
                    {resume['work'].map((work) => (
                        <VerticalTimelineElement
                            className="vertical-timeline-element--work"
                            // contentStyle={{ background: '#c01cc0', color: '#fff' }}
                            contentArrowStyle={{ borderRight: '7px solid  #c01cc0' }}
                            date={`${work.start.label ?? work.start} - ${work.end.label ?? work.end
                                }`}
                            iconStyle={{ background: 'transparent', color: '#fff' }}
                            // iconStyle={{ background: '#c01cc0', color: '#fff' }}
                            icon={<WorkIcon logo={work.logo}/>}
                        >
                            <h2 className="vertical-timeline-element-title">{work.title}</h2>
                            <h5 className="vertical-timeline-element-subtitle mb-2">{work.company}</h5>
                            <ul className="res_lul">
                                {work.feats.map((feat) => (
                                    <li className="res_lul">
                                        {feat}
                                    </li>
                                ))}
                            </ul>
                        </VerticalTimelineElement>
                    ))}
                </VerticalTimeline>
                <br /><br /><br /><br /><br />
                <center><h1 className="text-base text-zinc-800 dark:text-zinc-100 font-size-30px" >Education</h1></center>
                <VerticalTimeline>
                    {resume['education'].map((education) => (
                        <VerticalTimelineElement
                            className="vertical-timeline-element--work"
                            // contentStyle={{ background: '#c01cc0', color: '#fff' }}
                            contentArrowStyle={{ borderRight: '7px solid  #c01cc0' }}
                            date={`${education.start.label ?? education.start} - ${education.end.label ?? education.end
                                }`}
                            iconStyle={{ background: 'transparent', color: '#fff' }}
                            // iconStyle={{ background: '#c01cc0', color: '#fff' }}
                            icon={<WorkIcon logo={education.logo}/>}
                        >
                            <h2 className="vertical-timeline-element-title">{education.degree}</h2>
                            <h5 className="vertical-timeline-element-subtitle mb-2">{education.school}</h5>
                            <ul className="res_lul">
                                {education.feats.map((feat) => (
                                    <li className="res_lul">
                                        {feat}
                                    </li>
                                ))}
                            </ul>
                        </VerticalTimelineElement>
                    ))}
                </VerticalTimeline>
            </SimpleLayout>
        </>
    )
}
